import { createContext, FC } from 'react';

import { TableSectionContextProviderProps, TableSectionContextValue } from './Table.types';

export const TableSectionContext = createContext<TableSectionContextValue>(undefined);

const TableSectionContextProvider: FC<TableSectionContextProviderProps> = ({ value, children }) => {
  return <TableSectionContext.Provider value={value}>{children}</TableSectionContext.Provider>;
};

export default TableSectionContextProvider;
